/* LLCL Mobile Facets v9.0 — native details orchestration only. */
(()=>{
  const ROOT='[data-ll-mobile-facets]';
  const GROUP='details[data-ll-mf-group]';

  const normalize=root=>{
    if(!root)return;
    const open=[...root.querySelectorAll(`${GROUP}[open]`)];
    if(open.length<2)return;
    const keeper=open.find(group=>group.classList.contains('has-active'))||open[0];
    open.forEach(group=>{if(group!==keeper)group.removeAttribute('open');});
  };

  const prime=scope=>{
    if(scope?.matches?.(ROOT))normalize(scope);
    scope?.querySelectorAll?.(ROOT).forEach(normalize);
  };

  document.addEventListener('click',event=>{
    const summary=event.target.closest?.('.ll-mf9__summary');
    if(!summary)return;
    const group=summary.parentElement;
    if(!group?.matches?.(GROUP)||group.open)return;
    const root=group.closest(ROOT);
    root?.querySelectorAll(`${GROUP}[open]`).forEach(sibling=>{
      if(sibling!==group)sibling.removeAttribute('open');
    });
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>prime(document),{once:true});
  }else{
    prime(document);
  }

  document.addEventListener('shopify:section:load',event=>prime(event.target));
})();

/* LLCL Mobile Facets v9.2 loader.
   The filter runtime is already loaded by the standard PLP contract; attach the
   screenshot-correction layer here so concurrent layout writes cannot orphan it. */
(()=>{
  const ID='llcl-mobile-facets-v92';
  if(document.getElementById(ID))return;

  const script=document.currentScript || [...document.scripts].reverse().find(node=>/ll-collection-mobile-filters-v90\.js(?:\?|$)/.test(node.src));
  if(!script?.src)return;

  const link=document.createElement('link');
  link.id=ID;
  link.rel='stylesheet';
  link.href=new URL('ll-collection-mobile-filters-v92.css',script.src).href;
  document.head.appendChild(link);
})();
